<template>
    <div class="d-flex justify-center mt-10">
        <v-card
            class="pa-6 elevation-3 rounded-lg"
            style="max-width: 600px; width: 90%"
        >
            <v-card-title class="text-h5">
                {{ qrFile.title }}
            </v-card-title>

            <v-card-subtitle v-if="qrFile.description" class="description">
                {{ qrFile.description }}
            </v-card-subtitle>

            <v-divider class="my-4" />

            <div class="text-body-2 mb-4">
                Uploaded: {{ formatDate(qrFile.created_at) }}
            </div>

            <v-card-actions class="d-flex flex-column ga-4">
                <v-btn
                    color="primary"
                    variant="elevated"
                    block
                    :href="qrFile.file_url"
                    target="_blank"
                    class="easy-button"
                >
                    View File
                </v-btn>
                <v-btn
                    color="primary"
                    variant="tonal"
                    block
                    class="easy-button"
                    @click="downloadFile"
                >
                    Download File
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>

    <v-snackbar v-model="snackbar" timeout="2000">
        {{ snackbarText }}
    </v-snackbar>
</template>

<script>
import GuestLayout from "../../Layouts/GuestLayout.vue";
export default {
    props: {
        qrFile: Object,
    },
    layout: [GuestLayout],
    data() {
        return {
            snackbar: false,
            snackbarText: "",
        };
    },
    methods: {
        downloadFile() {
            const link = document.createElement("a");
            link.href = this.qrFile.file_url;
            link.download = this.qrFile.original_filename;
            link.click();
        },
        async copyLink() {
            try {
                await navigator.clipboard.writeText(window.location.href);
                this.snackbarText = "Link copied";
                this.snackbar = true;
            } catch (e) {
                this.snackbarText = "Failed to copy link";
                this.snackbar = true;
            }
        },
        formatDate(date) {
            return new Date(date).toLocaleDateString();
        },
    },
};
</script>

<style scoped>
.description {
    white-space: pre-wrap; /* preserves line breaks and spacing */
    line-height: 1.5;
}

.easy-button {
    padding: 24px 0;
    font-size: 16px;
}
</style>
